import { AriaRoles } from '../constants/AccessibilityConstants';
import { type ValueOf } from '../types';

export const AriaRolesArray: ValueOf<typeof AriaRoles>[] = Object.values(AriaRoles);
